import { FC } from 'react';
import { Tooltip } from '@mui/material';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import Icons from 'src/common/icons';

interface IProps {
  className: string;
  handleEdit: () => void;
  handleDelete: () => void;
  isDelete: boolean;
}

const ActionsSection: FC<IProps> = ({ className, handleEdit, handleDelete, isDelete }) => {
  const { role } = useTypedSelector(state => state.auth);

  return (
    <div className={`${className} icon_stroke`}>
      {role === 'admin' ? (
        <>
          <Tooltip title='Edit date'>
            <div className='action-box' onClick={handleEdit}>
              <Icons.Edit />
            </div>
          </Tooltip>
          <Tooltip title='Delete order'>
            <div className='action-box' onClick={handleDelete}>
              <Icons.Delete />
            </div>
          </Tooltip>
        </>
      ) : (
        <>
          <button
            children='Edit: when/where'
            className='order-show__header__edit-button'
            onClick={handleEdit}
          />
          {isDelete && (
            <Tooltip title='Delete order'>
              <div className='action-box' style={{ marginLeft: '5px' }} onClick={handleDelete}>
                <Icons.Delete />
              </div>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
};

export default ActionsSection;
